import styled from 'styled-components'

export const FiltersLayout = styled.div`
    display: flex;
    flex-direction: column;
`

export const AdvancedFilters = styled.div`
    overflow: hidden;
`
